import React from 'react';
import { Box, Divider } from '@mui/material';
import { generateShortId } from '@utils';

import InstaTaskSideBarItem from './InstaTaskSideBarItem';
import InstaTaskSidebarCopyItem from './InstaTaskSidebarCopyItem';

import styles from './instaTaskSideBar.styles';

const InstaTaskSideBar = ({ icon, sections = [] }) => {
  return (
    <Box sx={styles.instaSidebarWrapper}>
      {sections.map((section, index) => (
        <Box key={section.key || generateShortId()} sx={styles.sectionWrapper}>
          {section.title && (
            <Box sx={styles.titleWrapper}>
              {icon && <Box sx={styles.titleIcon}>{icon}</Box>}
              <Box sx={styles.title}>{section.title}</Box>
              {section.action}
            </Box>
          )}
          <Box sx={styles.itemsWrapper}>
            {section.subTitle}
            {section.items?.length > 0 &&
              section.items.map((item) => (
                <Box key={item.id} sx={styles.row}>
                  <Box sx={styles.rowTitle}>{item.title}</Box>
                  <Box sx={styles.copyValueWrapper}>
                    <InstaTaskSideBarItem item={item} />
                    {item?.showCopyValue && (
                      <InstaTaskSidebarCopyItem value={item?.value} />
                    )}
                  </Box>
                </Box>
              ))}
          </Box>
          {index < sections.length - 1 && <Divider sx={styles.divider} />}
        </Box>
      ))}
    </Box>
  );
};

export default InstaTaskSideBar;
